<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-attachment`]" width="1em" height="1em" v-bind="$attrs"><path d="M6.38818 1.09033C8.53539 1.09063 10.2767 2.83177 10.2769 4.979V7.07568C10.2769 7.0785 10.2759 7.08167 10.2759 7.08447V9.58154C10.2758 10.8389 9.25589 11.8579 7.99854 11.8579C6.74154 11.8575 5.72229 10.8386 5.72217 9.58154V7.07666C5.72217 6.7095 6.02009 6.4118 6.38721 6.41162C6.75448 6.41162 7.05225 6.70939 7.05225 7.07666V9.58154C7.05237 10.1041 7.47608 10.5274 7.99854 10.5278C8.52135 10.5278 8.94568 10.1043 8.9458 9.58154V7.07666L8.94678 4.979C8.94658 3.56631 7.80086 2.42071 6.38818 2.42041C4.97526 2.42041 3.82979 3.56613 3.82959 4.979V9.40869C3.82963 11.7117 5.69649 13.5794 7.99951 13.5796C10.3025 13.5793 12.1704 11.7117 12.1704 9.40869V7.07666C12.1704 6.70939 12.4682 6.41162 12.8354 6.41162C13.2024 6.412 13.5005 6.70963 13.5005 7.07666V9.40869C13.5005 12.4463 11.037 14.9094 7.99951 14.9097C4.96196 14.9095 2.49955 12.4463 2.49951 9.40869V4.979C2.49971 2.83159 4.24072 1.09033 6.38818 1.09033Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineAttachment',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
